<template>
  <div>
    <base-header class="pb-4">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Usuarios</h6>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <!--  <base-button size="sm" type="neutral">Filtros</base-button> -->
          <vue-json-to-csv
            :json-data="itemsToExport"
            :csv-title="'usuarios-' + new Date().valueOf()"
            :labels="labels"
            style="visibility: hidden"
          >
            <!--   <button>
              <b>My custom button</b>
            </button> -->
            <base-button size="sm" type="neutral" ref="myBtn"
              >Exportar</base-button
            >
          </vue-json-to-csv>
          <base-button
            size="sm"
            type="neutral"
            @click="exportData()"
            :loading="loading"
            >Exportar</base-button
          >
        </div>
      </div>
      <!-- Card stats -->
      <div class="row pt-1">
        <div class="col-xl-4 col-md-6">
          <stats-card
            title="Activos"
            type="gradient-green"
            :sub-title="totalActivos ? totalActivos.toString() : '0'"
            icon="ni ni-money-coins"
          >
            <template slot="footer">
              <span class="text-success mr-2"
                >{{
                  totalActivos
                    ? Math.floor((totalActivos * 100) / totalEmpleados)
                    : "0"
                }}%</span
              >
              <span class="text-nowrap">de los empleados</span>
            </template>
          </stats-card>
        </div>
        <div class="col-xl-4 col-md-6">
          <stats-card
            title="Inactivos"
            type="gradient-orange"
            :sub-title="totalInactivos ? totalInactivos.toString() : '0'"
            icon="ni ni-chart-pie-35"
          >
            <template slot="footer">
              <span class="text-success mr-2"
                >{{
                  totalInactivos
                    ? Math.floor((totalInactivos * 100) / totalEmpleados)
                    : "0"
                }}%</span
              >
              <span class="text-nowrap">de los empleados</span>
            </template>
          </stats-card>
        </div>
        <div class="col-xl-4 col-md-6">
          <stats-card
            title="Pendientes"
            type="gradient-red"
            :sub-title="totalPendientes ? totalPendientes.toString() : '0'"
            icon="ni ni-active-40"
          >
            <template slot="footer">
              <span class="text-success mr-2"
                >{{
                  totalPendientes
                    ? Math.floor((totalPendientes * 100) / totalEmpleados)
                    : "0"
                }}%</span
              >
              <span class="text-nowrap">de los empleados</span>
            </template>
          </stats-card>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--4">
      <div class="row">
        <div class="col">
          <card
            class="no-border-card"
            body-classes="px-0 pb-1"
            footer-classes="pb-2"
          >
            <div class="p-2">
              <div
                class="row col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <div class="col-md-4">
                  <div>
                    <form>
                      <base-input
                        v-model="query"
                        type="search"
                        prepend-icon="fas fa-search"
                        placeholder="Buscar por nombre, apellidos, email..."
                        clearable
                      />
                    </form>
                  </div>
                </div>
                <div class="col-md-8">
                  <div
                    class="d-flex justify-content-right justify-content-sm-end"
                  >
                    <div>
                      <el-select
                        class="select-primary pagination-select"
                        v-model="estado"
                        placeholder="Estado"
                        style="width: 100%; height: 46px !important"
                      >
                        <el-option
                          class="select-primary"
                          v-for="item in estados"
                          :key="item"
                          :label="item"
                          :value="item"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
              <el-table
                class="table-responsive align-items-center table-flush"
                header-row-class-name="thead-light"
                :data="users"
                @sort-change="sortChange"
                empty-text="No hay ningún elemento en esta tabla"
              >
                <div slot="empty" v-if="loading">
                  <img
                    src="/img/loading.gif"
                    style="height: 100px; width: 100px"
                  />
                </div>

                <el-table-column
                  label="Usuario"
                  sortable="custom"
                  min-width="100px"
                >
                  <template v-slot="{ row }">
                    <img
                      v-if="row.imagen_perfil && row.imagen_perfil.url"
                      :src="row.imagen_perfil.url"
                      class="avatar rounded-circle mr-2"
                    />
                    <img
                      v-else
                      src="/img/placeholder.png"
                      class="avatar rounded-circle mr-2"
                    />
                    <b>{{ row.nombre + " " + row.apellidos }}</b>
                  </template>
                </el-table-column>

                <!--   <el-table-column
                  label="Nombre"
                  min-width="60px"
                  prop="nombre"
                  sortable="custom"
                />
                <el-table-column
                  label="Apellidos"
                  min-width="60px"
                  prop="apellidos"
                  sortable="custom"
                /> -->
                <el-table-column
                  label="Email"
                  min-width="140px"
                  prop="email"
                  sortable="custom"
                />
                <!--  <el-table-column
                  label="Rol"
                  min-width="60px"
                  prop="role.name"
                  sortable="custom"
                >
                  <template v-slot="{ row }">
                    <span>{{ row.role.name }}</span>
                  </template>
                </el-table-column> -->
                <el-table-column
                  label="Estado"
                  min-width="70px"
                  prop="estado_usuario.id"
                  sortable="custom"
                >
                  <template slot-scope="{ row }">
                    <span
                      class="badge badge-default"
                      :style="[
                        row.estado_usuario.id == 1
                          ? { backgroundColor: 'orange' }
                          : row.estado_usuario.id == 2
                          ? { backgroundColor: 'green' }
                          : { backgroundColor: 'red' },
                      ]"
                      >{{ row.estado_usuario.estado }}</span
                    >
                  </template>
                </el-table-column>

                <el-table-column
                  label="Nº equipos"
                  min-width="70px"
                  sortable="custom"
                >
                  <template slot-scope="{ row }">
                    {{ row.activos.length }}
                  </template>
                </el-table-column>

                <el-table-column
                  label="Aptos"
                  prop="completion"
                  min-width="120px"
                  sortable
                >
                  <template v-slot="{ row }">
                    <div class="d-flex align-items-center">
                      <span class="completion mr-2">{{ row.aptos }}%</span>
                      <div>
                        <base-progress
                          :value="row.aptos"
                          :type="
                            row.aptos >= 90
                              ? 'success'
                              : row.aptos >= 50 && row.aptos < 90
                              ? 'warning'
                              : 'danger'
                          "
                        />
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="Acciones" align="left">
                  <div slot-scope="{ row }" class="table-actions">
                    <base-button
                      outline
                      size="sm"
                      type="primary"
                      @click="editUser(row)"
                      style="padding-left: 10px; padding-right: 10px"
                      >Editar</base-button
                    >
                    <base-button
                      outline
                      size="sm"
                      type="danger"
                      @click="deleteUser(row.id)"
                      style="padding-left: 10px; padding-right: 10px"
                      >Eliminar</base-button
                    >
                  </div>
                </el-table-column>
              </el-table>
            </div>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="row">
                <div class="col-xl-4">
                  <el-select
                    class="select-primary pagination-select"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div class="col-xl-8">
                  <p class="card-category" style="margin-top: 0.5rem">
                    Mostrando {{ total ? from + 1 : 0 }} - {{ to }} de
                    {{ total }} registros

                    <span v-if="selectedRows.length">
                      &nbsp; &nbsp; {{ selectedRows.length }} rows selected
                    </span>
                  </p>
                </div>
              </div>

              <base-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
              />
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { BasePagination } from "@/components";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import moment from "moment";
import "moment/locale/es"; // without this line it didn't work
moment.locale("es");

import VueJsonToCsv from "vue-json-to-csv";

export default {
  layout: "DashboardLayout",

  components: {
    BasePagination,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
  },

  data() {
    return {
      query: null,
      selectedRows: [],
      sort: "createdAt",
      total: 0,
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [25, 50, 100],
      },

      users: [],
      loading: true,

      estado: null,
      estados: ["", "Activo", "Inactivo", "Pendiente"],

      totalActivos: 0,
      totalInactivos: 0,
      totalPendientes: 0,
      totalEmpleados: 0,

      itemsToExport: [],

      labels: {
        username: { title: "Usuario" },
        nombre: { title: "Nombre" },
        apellidos: { title: "Apellidos" },
        email: { title: "Email" },
        telefono: { title: "Teléfono" },
        "role.name": { title: "Rol" },
        "estado_usuario.estado": { title: "Estado" },
      },
    };
  },
  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },
  watch: {
    query: {
      handler: "getListDebounced",
      immediate: true,
    },
    estado: {
      handler: "getListDebounced",
      immediate: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
  },

  methods: {
    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    async getList() {
      var planta = localStorage.getItem("plantaSelected");

      await this.$store.dispatch("profile/me");
      let profile = await this.$store.getters["profile/me"];
      console.log(profile);
      var empresas = [];
      profile.empresas.forEach((element) => {
        empresas.push(element.id);
      });

      if (planta != 0) {
        empresas = [planta];
      }

      var filters = {
        $and: [
          {
            empresas: {
              id: { $in: empresas },
            },
          },
          /*  {
            role: {
              id: { $in: 4 },
            },
          }, */
          { $or: [] },
        ],
      };

      if (this.query) {
        console.log(filters["$and"][2]["$or"]);

        filters["$and"][2]["$or"].push(
          {
            nombre: { $containsi: this.query },
          },
          {
            username: { $containsi: this.query },
          },
          {
            apellidos: { $containsi: this.query },
          },
          {
            email: { $containsi: this.query },
          }
        );
      }

      if (this.estado) {
        filters["$and"].push({
          estado_usuario: {
            estado: { $containsi: this.estado },
          },
        });
      }

      let params = {
        ...(this.sort ? { sort: this.sort } : {}),

        filters: filters,
        pagination: {
          page: this.pagination.currentPage,
          pageSize: this.pagination.perPage,
        },
      };
      await this.$store.dispatch("users/list", params).then(() => {
        var usrs = this.$store.getters["users/list"];
        /*   =  */

        usrs.forEach((usr) => {
          usr.aptos = parseInt(100);
          var naptos = 0;
          usr.activos.forEach((activo) => {
            if (
              moment(activo.fecha_prox_revision).isBefore(new Date().getTime())
            ) {
              naptos += 1;
            }
          });

          if (naptos > 0) {
            usr.aptos = parseInt(
              (
                ((usr.activos.length - naptos) * 100) /
                usr.activos.length
              ).toFixed(0)
            );
          }
        });

        this.users = usrs;

        console.log(this.users);
        this.total = this.$store.getters["users/listTotal"];
        if (this.total > this.totalEmpleados) {
          this.totalEmpleados = this.total;
        }
        this.loading = false;
      });

      var filtersActivos = {
        $and: [
          {
            empresas: {
              id: { $in: empresas },
            },
          },
          /*   {
            role: {
              id: { $in: 4 },
            },
          }, */
          {
            estado_usuario: {
              estado: { $containsi: "activo" },
            },
          },
        ],
      };
      await this.$store
        .dispatch("users/list", {
          filters: filtersActivos,
        })
        .then(() => {
          this.totalActivos = this.$store.getters["users/listTotal"];
        });

      var filtersInctivos = {
        $and: [
          {
            empresas: {
              id: { $in: empresas },
            },
          },
          /*  {
            role: {
              id: { $in: 4 },
            },
          }, */
          {
            estado_usuario: {
              estado: { $containsi: "inactivo" },
            },
          },
        ],
      };
      await this.$store
        .dispatch("users/list", {
          filters: filtersInctivos,
        })
        .then(() => {
          this.totalInactivos = this.$store.getters["users/listTotal"];
        });

      var filtersPendientes = {
        $and: [
          {
            empresas: {
              id: { $in: empresas },
            },
          },

          {
            estado_usuario: {
              estado: { $containsi: "pendiente" },
            },
          },
        ],
      };
      await this.$store
        .dispatch("users/list", {
          filters: filtersPendientes,
        })
        .then(() => {
          this.totalPendientes = this.$store.getters["users/listTotal"];
        });
    },

    async exportData() {
      this.loading = true;
      var planta = localStorage.getItem("plantaSelected");

      await this.$store.dispatch("profile/me");
      let profile = await this.$store.getters["profile/me"];
      console.log(profile);
      var empresas = [];
      profile.empresas.forEach((element) => {
        empresas.push(element.id);
      });

      if (planta != 0) {
        empresas = [planta];
      }

      var filters = {
        $and: [
          {
            empresas: {
              id: { $in: empresas },
            },
          },
          /*  {
      role: {
        id: { $in: 4 },
      },
    }, */
          { $or: [] },
        ],
      };

      if (this.query) {
        console.log(filters["$and"][2]["$or"]);

        filters["$and"][2]["$or"].push(
          {
            nombre: { $containsi: this.query },
          },
          {
            username: { $containsi: this.query },
          },
          {
            apellidos: { $containsi: this.query },
          },
          {
            email: { $containsi: this.query },
          }
        );
      }

      if (this.estado) {
        filters["$and"].push({
          estado_usuario: {
            estado: { $containsi: this.estado },
          },
        });
      }

      let params = {
        ...(this.sort ? { sort: this.sort } : {}),

        filters: filters,
        pagination: {
          page: this.pagination.currentPage,
          pageSize: this.pagination.perPage,
        },
      };
      await this.$store.dispatch("users/list", params).then(async () => {
        let paramsExport = {
          ...(this.sort ? { sort: this.sort } : {}),

          filters: filters,
          pagination: {
            page: 1,
            pageSize: this.$store.getters["users/listTotal"],
          },
        };

        await this.$store.dispatch("users/list", paramsExport).then(() => {
          var items = this.$store.getters["users/list"];

          console.log(items.length);

          var itemsFlatten = [];
          items.forEach((item) => {
            itemsFlatten.push(this.flattenObject(item));
          });

          console.log(itemsFlatten);

          this.itemsToExport = itemsFlatten;

          /* const elem = this.$refs.myBtn;
          elem.click(); */
          setTimeout(() => {
            this.$refs.myBtn.$el.click();
            this.loading = false;
          }, 500);
        });
      });
    },
    flattenObject(obj) {
      let flattenKeys = {};
      for (let i in obj) {
        if (!obj.hasOwnProperty(i)) continue;
        if (typeof obj[i] == "object") {
          // flattenKeys[i] = obj[i];
          let flatObject = this.flattenObject(obj[i]);
          for (let j in flatObject) {
            if (!flatObject.hasOwnProperty(j)) continue;
            flattenKeys[i + "." + j] = flatObject[j];
          }
        } else {
          flattenKeys[i] = obj[i];
        }
      }
      return flattenKeys;
    },
    async deleteUser(id) {
      if (this.$isDemo && ["1", "2", "3"].includes(id)) {
        this.$notify({
          type: "danger",
          message: "You are not allowed not change data of default users.",
        });
        return;
      }
      const confirmation = await swal.fire({
        title: `¿Eliminar este usuario?`,
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "No, mantenerlo",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.value === true) {
          await this.$store.dispatch("users/destroy", id);
          await this.getList();
          this.$notify({
            type: "success",
            message: "Usuario eliminado correctamente.",
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Oops, ha habido un error",
        });
      }
    },
    addUser() {
      this.$router.push({ name: "Add User" });
    },
    async editUser(row) {
      /*  await this.$store.dispatch("profile/me");
      let me = await this.$store.getters["profile/me"];

      if (row.id === me.id) {
        this.$router.push({ name: "User Profile" });
      } else { */
      this.$router.push({
        name: "Edit User",
        params: { id: row.id },
      });
      /*  } */
    },
    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `-${prop}`;
      } else {
        this.sort = `${prop}`;
      }
      this.getList();
    },
  },
};
</script>
